import { memo } from 'react'
import { Row, Col, Container } from "react-bootstrap";


const SipDetails = ({ sipDetails }) => {

    return (

        <>
            <Container fluid className='p-0'>
                <Row className='g-0'>
                    <Col md={5} className='mrgauto'>
                        <Row className='g-0 mb-3'>
                            <Col>
                                <table className='table table-hover table-bordered'>
                                    <tbody>
                                        <tr>
                                            <th className='text-left'>
                                                <div className='font-size2 color-text text-capitalize py-2'>Amount</div>
                                            </th>
                                            <td className='text-left'>
                                                <div className='font-regular font-size2 color-text text-capitalize py-1'>&#8377;{sipDetails[0]?.amount}</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th className='text-left'>
                                                <div className='font-size2 color-text text-capitalize py-2'>Frequency</div>
                                            </th>
                                            <td className='text-left'>
                                                <div className='font-regular font-size2 color-text text-capitalize py-1'>{sipDetails[1]?.frequency}</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th className='text-left'>
                                                <div className='font-size2 color-text text-capitalize py-2'>Start Date</div>
                                            </th>
                                            <td className='text-left'>
                                                <div className='font-regular font-size2 color-text text-capitalize py-1'>{sipDetails[2]?.startDate}</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th className='text-left'>
                                                <div className='font-size2 color-text text-capitalize py-2'>End Date</div>
                                            </th>
                                            <td className='text-left'>
                                                <div className='font-regular font-size2 color-text text-capitalize py-1'>{sipDetails[3]?.endDate}</div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default memo(SipDetails)